import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
@Component({
  selector: 'app-trustpayment',
  templateUrl: './trustpayment.component.html',
  styleUrls: ['./trustpayment.component.scss'],
})
export class TrustpaymentComponent {
  @ViewChild('trustpaymentsForm') trustpaymentsForm: ElementRef;
  requestJSON: any;

  submitForm(requestJSON: any) {
    this.requestJSON = requestJSON;
    setTimeout((_) => this.trustpaymentsForm.nativeElement?.submit());
  }
}
